import script from "./LivenessScanStep.vue?vue&type=script&setup=true&lang=js"
export * from "./LivenessScanStep.vue?vue&type=script&setup=true&lang=js"

import "./LivenessScanStep.vue?vue&type=style&index=0&id=a34d26a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a34d26a2"]])

export default __exports__